import styles from './Skeleton.module.css';

const SkeletonElement = ({ type }) => {
  // const classes = `skeleton ${type}`;
  return <div className={styles[type]}></div>;
};

export default SkeletonElement;
